module.exports = __webpack_public_path__ + "static/ishizakaImg-adc96d338347d56ae98dd01ef11e360d.jpg";